import state from './modulePhilosophiesState.js'
import mutations from './modulePhilosophiesMutations.js'
import actions from './modulePhilosophiesActions.js'
import getters from './modulePhilosophiesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

